export function getFileNames() {
  const translationModules = import.meta.glob('../../../assets/locales/**/*.json', {
    eager: true,
  });

  const languages = new Set<string>();
  const namespaces = new Set<string>();
  const filesByLanguage: Record<string, string[]> = {};

  Object.keys(translationModules).forEach(path => {
    const match = path.match(/\/locales\/([^/]+)\/([^/]+)\.json$/);

    if (match) {
      const [, language, namespace] = match;
      languages.add(language);
      namespaces.add(namespace);

      if (!filesByLanguage[language]) {
        filesByLanguage[language] = [];
      }

      filesByLanguage[language].push(namespace);
    }
  });

  return {
    languages: Array.from(languages),
    namespaces: Array.from(namespaces),
    filesByLanguage,
    modules: translationModules,
  };
}
